const projects = [
    {
        id: 1,
        link:"https://github.com/prathmeshtech/RestroSite" ,
        title: "Restro Booking",
        info: " Arestaurant site where customer can book tables, order food, and can contact Local delivery partners from a single site.",
        date:"Sep 2021"
    },
    {
        id: 2,
        link:"https://github.com/prathmeshtech/Weatherify" ,
        title: "Weatherify",
        info: " Frontend: React, Handlebars Template Engine, BootStrap4, CSS3 Backend Technologies: Express, Node.js, Current Weather API from openweathermap.org, Postman tool.",
        date:"Aug 2021"
    },
    {
        id: 3,
        link:"https://github.com/prathmeshtech/CVBuilder_FullStack" ,
        title: "CV-Builder",
        info: "Will take your information and Generate a templated CV that can be printed.",
        date:"May-Aug 2021"
    },
    {
        id: 4,
        link: "https://github.com/prathmeshtech/VaccineSlot_Notifier" ,
        title: "VaccineSlot Notifier",
        info: " This Project is made to simplify the process of vaccine booking. To make it to our fingertips, vaccine availability notification will be pushed on to our telegram group by a telegram bot. We have used cowin API of calendarByDistrict which is publicly available on apisetu.gov.in site.",
        date:"Sep 2021"
    },
    {
        id: 5,
        link:"" ,
        title: "Personsal React WebSite",
        info: "Made Using React, Material UI, Bootstrap5, and also made reusable Components. Live Chat Support Integrated and Firebase Realtime Database aswell.",
        date:"Sep 2021"
    },
    {
        id: 6,
        link:"" ,
        title: "RESTfull API testing",
        info: "Testing RESTful API's method.",
        date:"Jul 2021"
    },
]

export default projects